// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cards_cards__1BXST","page":"Cards_page__8p1nm"};